import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=3d9045f8&"
import script from "./AdminHome.vue?vue&type=script&lang=js&"
export * from "./AdminHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9045f8')) {
      api.createRecord('3d9045f8', component.options)
    } else {
      api.reload('3d9045f8', component.options)
    }
    module.hot.accept("./AdminHome.vue?vue&type=template&id=3d9045f8&", function () {
      api.rerender('3d9045f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminHome.vue"
export default component.exports